import { Editor } from "primereact/editor"
import styles from "../../../styles/CoordinationBoards.module.css"
import { renderRequireFieldErrorMessage } from "./Utils"
import Quill from "quill"
import QuillMention from "quill-mention"
Quill.register('modules/mention', QuillMention)

const EditorField = ({ label, subLabel, required, placeholder,
  value, onTextChange, disabled, showRequiredFieldMge, suggestions }
) => {

  const mentionModule = {
    mention: {
      mentionDenotationChars: ["@"],
      source: (searchTerm, renderList) => {
        let matches = []
        if (searchTerm.length === 0) {
          matches = suggestions
        } else {
          matches = suggestions.filter(suggestion => {
            return suggestion.value.toLowerCase().startsWith(searchTerm.toLowerCase())
          })
        }
        renderList(matches, searchTerm)
      },
      renderItem: (item, searchTerm) => {
        let span = document.createElement('span')
        span.textContent = item.value
        if (!item.choosable) {
          span.className = 'disabled'
        } else {
          span.className = 'choosable'
        }
        return span
      }
    }
  }

  const renderHeader = () => {
    return (
      <>
        <span className="ql-formats">
          <button className="ql-bold" aria-label="Bold"></button>
          <button className="ql-italic" aria-label="Italic"></button>
        </span>
        <span className="ql-formats">
          <button className="ql-underline" aria-label="Underline"></button>
          <button className="ql-strike" aria-label="Strike"></button>
          <button className="ql-link" aria-label="Link"></button>
        </span>
        <span className="ql-formats">
          <button
            type="button"
            className="ql-list"
            value="ordered"
            aria-label="Ordered List"
          ></button>
          <button
            type="button"
            className="ql-list"
            value="bullet"
            aria-label="Unordered List"
          ></button>
        </span>
      </>
    )
  }

  const header = renderHeader()
  return (
    <div className={styles.field}>
      {label != null ? (
        <label className={`${styles.label} ${required ? styles.required : ""}`}>{label}</label>
      ) : (
        ""
      )}
      {subLabel != null ? (
        <label className={styles.sub_label}>{subLabel}</label>
      ) : (
        ""
      )}
      <Editor
        placeholder={placeholder ? placeholder : ""}
        value={value}
        modules={suggestions?.length > 0 ? mentionModule : {}}
        onTextChange={(e) => {
          //Prevent user from adding unwanted attributes by copy/pasting
          const anyUnwantedAttr = e.delta.ops.some((item) => {
            if (item.hasOwnProperty("attributes")) {
              return Object.getOwnPropertyNames(item.attributes).some(
                (p) =>
                  p !== "bold" &&
                  p !== "italic" &&
                  p !== "underline" &&
                  p !== "strike" &&
                  p !== "link" &&
                  p !== "list"
              )
            }
            return false
          })
          if (!anyUnwantedAttr) {
            onTextChange(e.htmlValue)
          } else {
            //If unwanted attributes are found return the original value to prevent the change
            onTextChange(value ? value : "" + " ")
          }
        }}
        headerTemplate={header}
        readOnly={disabled}
        className={`${styles.editor_field} custom_editor`}
        style={{ height: "140px" }}
      />
      {showRequiredFieldMge !== undefined && showRequiredFieldMge && renderRequireFieldErrorMessage(
        value,
        `${label} is required`
      )}
    </div>
  )
}

export default EditorField 